export default __webpack_public_path__ + "static/media/Banner2022_Mechanic-min.df641757.png";